import { Navigate, Route, Routes } from "react-router-dom";
import OrganisationGroupsDashboard from "../pages/Dashboard";
import OrganisationGroupsStaff from "../pages/Staff";
import OrganisationGroupsMemberOrganisations from "../pages/MemberOrganisations";
import OrganisationGroupsTeacherDetail from "../pages/TeacherDetail";
import OrganisationGroupsSettings from "../pages/Settings";
import OrganisationGroupsSchoolDetails from "../pages/SchoolDetails";
import OrganisationPrivateRoutesSuspense from "../layout/OrganisationPrivateRoutesSuspense";

export default function OrganisationRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/organisations/dashboard" replace />} />
      <Route
        path="/dashboard"
        element={
          <OrganisationPrivateRoutesSuspense>
            <OrganisationGroupsDashboard />
          </OrganisationPrivateRoutesSuspense>
        }
      />
      <Route
        path="/staff"
        element={
          <OrganisationPrivateRoutesSuspense>
            <OrganisationGroupsStaff />
          </OrganisationPrivateRoutesSuspense>
        }
      />
      <Route
        path="/member-organisations"
        element={
          <OrganisationPrivateRoutesSuspense>
            <OrganisationGroupsMemberOrganisations />
          </OrganisationPrivateRoutesSuspense>
        }
      />
      <Route
        path="/teacher-detail/:id"
        element={
          <OrganisationPrivateRoutesSuspense>
            <OrganisationGroupsTeacherDetail />
          </OrganisationPrivateRoutesSuspense>
        }
      />
      <Route
        path="/settings"
        element={
          <OrganisationPrivateRoutesSuspense>
            <OrganisationGroupsSettings />
          </OrganisationPrivateRoutesSuspense>
        }
      />
      <Route
        path="/school-details"
        element={
          <OrganisationPrivateRoutesSuspense>
            <OrganisationGroupsSchoolDetails />
          </OrganisationPrivateRoutesSuspense>
        }
      />
    </Routes>
  );
}
